import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import MapWrapper from './Styles';
import DealerMap from '../DealerMap';
import Filter from '../Filter';

const propTypes = {
  updateFilter: PropTypes.func,
  isMobile: PropTypes.bool,
  filterMetaData: PropTypes.shape({
    isFranchiseDealer: PropTypes.bool,
    hasTradeIn: PropTypes.bool
  }).isRequired,
  onSelectDealer: PropTypes.func
};

const defaultProps = {
  updateFilter: () => null,
  isMobile: false,
  onSelectDealer: () => null
};

const TiahDealerMapContainer = forwardRef(
  ({ updateFilter, isMobile, filterMetaData, onSelectDealer }, ref) => {
    return (
      <MapWrapper>
        <Filter updateFilter={updateFilter} isMobile={isMobile} ref={ref} />
        <DealerMap
          filterMetaData={filterMetaData}
          isMobile={isMobile}
          onSelectDealer={onSelectDealer}
        />
      </MapWrapper>
    );
  }
);

TiahDealerMapContainer.defaultProps = defaultProps;
TiahDealerMapContainer.propTypes = propTypes;

export default TiahDealerMapContainer;
